import { put, call } from 'redux-saga/effects';

import { destroyToken } from '@helpers/user';
import { getUserDetailsSaga } from '@sagas/user/getUserDetailsSaga';
import { userGetFailureAction } from '@store/user/user.actions';

export const handleGetUserSaga = function* ({ payload }) {
  try {
    yield call(getUserDetailsSaga, { payload });
  } catch (error) {
    destroyToken();
    yield put(userGetFailureAction(error));
  }
};
